import React, { useContext } from 'react';
import { Grid, Paper } from '@mui/material';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { createReservation } from '../../../../../utils/requests';
import { IOrder } from '../../../../../interfaces/bookingContext';
import { PurchaseItem, PurchaseUnit } from '@paypal/paypal-js/types/apis/orders';
import { IRoomType } from '../../../../../interfaces/suite8';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../utils/appContext';

const PayPal = () => {
  let history = useHistory();
  const appContext = useContext(AppContext);
  const configs = appContext.getProperty(appContext.website);
  const keyPaymentMethods =
    process.env.NODE_ENV === 'development' ? 'payment_methods_test' : 'payment_methods';
  const CLIENT_ID = configs[keyPaymentMethods].find((pm: any) => pm.name === 'paypal').key;

  const buildPurchaseUnitsObject = (orders: IOrder[]): PurchaseUnit[] => {
    const purchaseItem: PurchaseItem[] = [];

    appContext.orders = orders;

    const amountToPay = appContext.orders[0].Deposit
      ? appContext.getDepositPrice().toFixed(2)
      : appContext.getTotalPrice().toFixed(2);

    appContext.orders.forEach((order: IOrder) => {
      if (order.GuestNum) {
        purchaseItem.push({
          name: appContext.roomTypes.find(
            (room: IRoomType) => room.RoomTypeShortDesc === order.RoomType
          ).RoomTypeLongDesc,
          unit_amount: {
            currency_code: 'EUR',
            value: amountToPay
          },
          quantity: '1',
          sku: order.Property + order.GuestNum
        });
      }
    });

    return [
      {
        amount: {
          currency_code: 'EUR',
          value: amountToPay,
          breakdown: {
            item_total: {
              value: amountToPay,
              currency_code: 'EUR'
            }
          }
        },
        items: purchaseItem
      }
    ];
  };

  return (
    <Grid item xs={12}>
      <Paper elevation={0}>
        <PayPalScriptProvider
          options={{
            'client-id': CLIENT_ID,
            currency: 'EUR'
          }}>
          <PayPalButtons
            style={{
              color: 'white',
              label: 'pay',
              layout: 'horizontal'
            }}
            fundingSource={'paypal'}
            createOrder={async (data, actions) => {
              const orderResponse = await createReservation(appContext.orders);
              appContext.orders.map((order: IOrder) => {
                const reservation: IOrder = orderResponse.data.data.find(
                  (orderResponse: IOrder) => orderResponse.ProfileID == order.ProfileID
                );
                if (reservation) {
                  order.GuestNum = reservation.GuestNum;
                }
                return order;
              });
              appContext.setOrders([...appContext.orders]);
              return actions.order.create({
                purchase_units: buildPurchaseUnitsObject(appContext.orders),
                intent: 'CAPTURE',
                application_context: {
                  shipping_preference: 'NO_SHIPPING',
                  user_action: 'PAY_NOW',
                  payment_method: {
                    payee_preferred: 'IMMEDIATE_PAYMENT_REQUIRED'
                  }
                }
              });
            }}
            onApprove={async (data, actions) => {
              if (actions.order) {
                return actions.order.capture().then(function (details) {
                  // This function shows a transaction success message to your buyer.
                  history.push('/accepted');
                });
              }
            }}
            onError={(err) => {
              console.error(err);
              history.push('/denied');
            }}
          />
        </PayPalScriptProvider>
      </Paper>
    </Grid>
  );
};

export default PayPal;
